const footerLinks = [
  { label: "作品简介", href: "#intro" },
  { label: "阅读入口", href: "#entries" },
  { label: "章节目录", href: "#chapters" },
  { label: "读者书评", href: "#reviews" },
  { label: "常见问题", href: "#faq" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-50 border-t border-primary-100">
      <div className="mx-auto max-w-6xl px-4 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="flex items-end gap-3">
              <span className="font-heading text-2xl text-foreground-950">迷人的保姆</span>
              <span className="pb-1 text-xs font-label tracking-[0.3em] text-primary-600">
                READING
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              一个专注于《迷人的保姆》的阅读聚合页：章节列表、全文阅读、无删减版与
              txt 下载集中在一处，让你随时打开都能接着往下读。
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-xs font-label tracking-[0.24em] uppercase text-foreground-500">
              站内导航
            </h3>
            <ul className="mt-4 space-y-3">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm font-label text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-xs font-label tracking-[0.24em] uppercase text-foreground-500">
              阅读提示
            </h3>
            <ul className="mt-4 space-y-3 text-sm font-label text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-primary-500" />
                最近更新：2026-09-28
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-book-2-line mt-0.5 text-primary-500" />
                已完结 · 共 1,286 章
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-smartphone-line mt-0.5 text-primary-500" />
                支持手机与电脑阅读
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-primary-100 pt-6">
          <p className="text-xs font-label text-foreground-500">
            © 2026 迷人的保姆 · 全文阅读合集
          </p>
          <p className="text-xs font-label text-foreground-400">
            本站内容仅用于阅读展示，章节与文字版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}